/* eslint-disable prettier/prettier */
// src/modules/owner/pages/actions/tanqueCheio/components/VoucherModal.jsx
import PropTypes from 'prop-types';
import { BASE_S3, COMPANY_COLORS } from 'config/consts';
import moment from 'moment';
import React from 'react';
import LogoClubs from '../../../../../../assets/img/logo_clubs.svg';
const QRCode = require('qrcode.react');

export default function VoucherModal({ colors, formValues }) {
  // Se tiver tema, usa o logo do S3; senão, usa o SVG local
  const logoUrl = colors
    ? `${BASE_S3}/${COMPANY_COLORS(colors).homepage.sidebar.logo}`
    : LogoClubs;

  const btnTheme = colors
    ? COMPANY_COLORS(colors).general.secondaryButton
    : {
        background: '#28a745',
        text:       '#ffffff',
        border:     '#28a745',
      };

  return (
    <div
      style={{
        display:        'flex',
        width:          '100%',
        height:         '100%',
        flexDirection:  'column',
        alignItems:     'center',
        backgroundColor:'#FAFAFA',
      }}
    >
      <div
        className="container-fluid d-flex-column justify-content-space-around"
        style={{
          backgroundColor: '#fff',
          width:            497,
          height:           'calc(100vh - 260px)',
          overflowY:       'auto',
          overflowX:       'hidden',
          paddingRight:    15,
        }}
      >
        {/* LOGO */}
        <div className="row justify-content-center mt-5">
          <div className="col-8 col-md-4">
            <img
              src={logoUrl}
              alt="LOGO-EMPRESA"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>
        </div>

        {/* NOME */}
        <div className="row justify-content-center mt-5">
          <div className="col-auto text-center">
            <h4>{formValues.name}</h4>
          </div>
        </div>

        <div className="row justify-content-center mt-3">
          <div className="col-md-8 col-11">
            <h6 className="text-muted text-center">
              {`Voucher gerado em: ${moment().format('LLLL')}`}
            </h6>
          </div>
        </div>

        <div className="row justify-content-center mt-4">
          <div className="col-auto">
            <QRCode value={formValues.qrValue || ''} />
          </div>
        </div>

        <div className="row justify-content-center mt-3">
          <div className="col-auto">
            <h5 className="text-muted">{formValues.voucherCode}</h5>
          </div>
        </div>

        {formValues.local && (
          <div className="row justify-content-center mt-4">
            <div className="col-md-auto col-11">
              <p className="text-muted">{formValues.local}</p>
            </div>
          </div>
        )}

        <div className="row justify-content-center mt-3">
          <div className="col-md-auto col-11">
            <h6 className="text-muted mb-0 text-center">
              Este voucher deverá ser utilizado até:
            </h6>
          </div>
        </div>
        <div className="row justify-content-center mt-0">
          <div className="col-md-auto col-11">
            <h6 className="text-muted text-center">
              {moment(formValues.validUntil).format('LLLL')}
            </h6>
          </div>
        </div>

        {/* BOTÃO IMPRIMIR */}
        <div className="row justify-content-center mt-5">
          <div className="col-md-auto col-11">
            <div
              className="py-3 station-font-medium"
              style={{
                background:   btnTheme.background,
                color:        btnTheme.text,
                border:       `1px solid ${btnTheme.border}`,
                borderRadius: 8,
                paddingLeft:  140,
                paddingRight: 140,
                cursor:       'pointer',
                fontSize:     '1rem',
                textAlign:    'center',
              }}
            >
              Imprimir
            </div>
          </div>
        </div>

        {/* LINK PÁGINA INICIAL */}
        <div className="row justify-content-center mt-2 mb-5">
          <div className="col-auto">
            <a
              href="#/homepage"
              style={{ textDecoration: 'underline', color: '#505050' }}
            >
              Página inicial
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

VoucherModal.propTypes = {
  colors:     PropTypes.any,
  formValues: PropTypes.shape({
    name:        PropTypes.string.isRequired,
    qrValue:     PropTypes.string,
    voucherCode: PropTypes.string,
    local:       PropTypes.string,
    validUntil:  PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  }).isRequired,
};